// Editorial content for the Our Vision section
// All copy is client-approved.

export const vision = {
  eyebrow: "OUR VISION",
  openingHeadline: "Building the brands of tomorrow.",
  openingSupport: "Where ideas, talent and technology come into flow.",

  // Full approved vision statement (do not paraphrase)
  statement:
    "To build an enduring global apparel enterprise where ideas, talent and technology flow together to enable the brands of tomorrow.",

  statementParts: [
    { text: "To build an", emphasis: null },
    { text: "enduring", emphasis: "purple" },
    { text: "global apparel enterprise", emphasis: null },
    { text: "where ideas, talent and technology", emphasis: null },
    { text: "flow together", emphasis: "green" },
    { text: "to enable the", emphasis: null },
    { text: "brands of tomorrow.", emphasis: "purple" },
  ],

  stages: [
    {
      key: "idea",
      label: "IDEA",
      caption: "A fine sketch line and the beginning of a possibility.",
    },
    {
      key: "product",
      label: "PRODUCT",
      caption: "The line gains texture, material and form.",
    },
    {
      key: "brand",
      label: "BRAND",
      caption: "The material develops into a distinctive apparel expression.",
    },
    {
      key: "scale",
      label: "GLOBAL SCALE",
      caption: "The finished expression moves toward an open international horizon.",
    },
  ],

  forces: [
    {
      key: "ideas",
      label: "IDEAS",
      body: "Product thinking, material innovation and new business possibilities.",
    },
    {
      key: "talent",
      label: "TALENT",
      body: "Human capability, experience, craftsmanship and entrepreneurial leadership.",
    },
    {
      key: "technology",
      label: "TECHNOLOGY",
      body: "Connected systems, intelligent execution, traceability and emerging textiles.",
    },
  ],

  convergenceTitle: "BRANDS OF TOMORROW",
  convergenceSupport:
    "Transforming apparel possibilities into scalable businesses.",

  narrativePull:
    "We see apparel not as an endpoint, but as the foundation of an enduring enterprise.",
  narrativeBody:
    "Nyle brings together creative thinking, human capability and connected technology to transform apparel possibilities into scalable businesses. We begin with apparel\u2014and build with the ambition, systems and adaptability to endure across generations.",

  horizons: [
    {
      key: "today",
      label: "TODAY",
      title: "Nyle Apparel",
      body: "Building a connected platform for global apparel brands.",
    },
    {
      key: "tomorrow",
      label: "TOMORROW",
      title: "Future Businesses",
      body: "",
    },
    {
      key: "forever",
      label: "FOREVER",
      title: "Nyle Group",
      body: "An adaptable enterprise designed to endure across generations.",
    },
  ],

  closingLine1: "Our vision defines where we are going.",
  closingLine2: "Built for Flow defines how we intend to get there.",
  closingHero: "Built for Flow.",
  closingSub: "Build. Brand. Scale with NYLE.",
  closingLink: "Discover How We Work",
};
